var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-stack",attrs:{"aria-live":"polite","aria-label":"Fleet alerts"}},_vm._l((_vm.alerts),function(alert){return _c('AlertToast',{key:alert.id,attrs:{"alert":alert,"duration":30000},on:{"dismissed":_vm.remove,"view-detail":_vm.onViewDetail}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }